




































































































import {Component, Prop, Vue} from "vue-property-decorator";
import KInput from "../components/KInput.vue";
import AdminNav from "../components/TopNav.vue";
import TopNav from "../components/AdminNav.vue";
import moment from "moment";
import {EventNotes} from "../models/EventNotes";
import CalendarEvent from "../models/CalendarEvent";
import {DATE_FORMAT, DATETIME_FORMAT, TIME_FORMAT} from "../models/Model";
import axios from "axios";
import queryString from "query-string";
import {getConfig, me, verifyAuth} from "../session";
import {Settings} from "../models/Settings";

@Component({
    components: {KInput, AdminNav, TopNav},
})
export default class ManageEvent extends Vue {
    protected eventObj: CalendarEvent = CalendarEvent.blank;
    protected comments: EventNotes[] = [];
    protected eid!: number;
    protected isNew: boolean = false;
    protected settings!: Settings;
    protected granulars: moment.Moment[] = [];

    // TODO improve this
    private userCache: { [key: number]: "loading" | { displayname: string } } = {};

    public created() {
        verifyAuth();
        const queries = queryString.parse(window.location.search);
        if (queries.eid as string === "new") {
            this.eventObj = CalendarEvent.blank;
            me().then((m) => {
                this.eventObj.creator = this.eventObj.modifier = m.uid;
            });
            this.isNew = true;
        } else {
            this.isNew = false;
            this.eid = parseInt(queries.eid as string, 10);
            axios.get(process.env.VUE_APP_ROOT_API + "/events/" + this.eid, {withCredentials: true})
                .then((res) => {
                    this.eventObj = CalendarEvent.fromJson(res.data.data);
                });
            axios.get(process.env.VUE_APP_ROOT_API + "/events/" + this.eid + "/notes", {withCredentials: true})
                .then((res) => {
                    for (const evtNote of res.data.data) {
                        this.comments.push(EventNotes.fromJson(evtNote));
                    }
                });
        }
        getConfig().then((cfg) => {
            this.settings = cfg;
            this.granulars.length = 0;
            let curGran = cfg.firstTee.clone();
            while (curGran.isBefore(cfg.lastTee)) {
                this.granulars.push(curGran);
                curGran = curGran.clone().add(cfg.granularity);
            }
            if (this.isNew) {
                this.startTime = "12:00";
            }
        });
    }

    protected getUser(uid: number) {
        if (this.userCache[uid] !== null && this.userCache[uid] !== undefined) {
            return this.userCache[uid];
        } else if (this.userCache[uid] !== "loading") {
            this.userCache[uid] = "loading";
            axios.get(process.env.VUE_APP_ROOT_API + "/users/" + uid, {withCredentials: true}).then((res: any) => {
                this.userCache[uid] = res.data.data;
                this.$forceUpdate();
            });
        }
        return {
            displayname: "loading...",
        };
    }

    protected onSendClicked(evt: MouseEvent) {
        const input: HTMLTextAreaElement = this.$refs.notesInput as HTMLTextAreaElement;
        if (input.value && input.value.trim()) {
            const msg = input.value.trim();
            input.value = "";

            // TODO get author ID
            me().then((m) => {
                const en = new EventNotes(this.eid, -1, m.uid, msg, moment().toISOString());
                this.comments.push(en);
                en.saveNew();

                input.focus();
            });
        }
    }

    protected onSaveClicked(evt: MouseEvent) {
        if (this.isNew) {
            this.eventObj.saveNew().then((id) => {
                window.location.replace("?eid=" + id);
            });
        } else {
            this.eventObj.save();
        }
    }

    protected onDeleteClicked(evt: MouseEvent) {
        window.location.pathname = "/";
    }

    protected onBackClicked(evt: MouseEvent) {
        window.history.back();
    }

    protected get startDate() {
        return this.eventObj.start.format(DATE_FORMAT);
    }

    protected set startDate(val) {
        this.eventObj.start = moment(val + this.startTime, DATETIME_FORMAT);
    }

    protected get startTime() {
        return this.eventObj.start.format("H:mm");
    }

    protected set startTime(val) {
        this.eventObj.start = moment(this.startDate + val, "YYYY-MM-DDH:mm");
        this.eventObj.finish = this.eventObj.start.clone().add(this.settings.cooldown);
        // this.$forceUpdate();
    }

    protected get finishTime() {
        return this.eventObj.finish.format("H:mm");
    }

    protected set finishTime(val) {
        this.eventObj.finish = moment(val, "H:mm");
    }
}
